import React, { Component } from 'react'
import classNames from 'class-names'
import without from 'lodash.without'
import union from 'lodash.union'
import Toast from '../../components/Toast'
import SchoolDetail from '../School/Detail/index'
import iconAdd from '../../assets/svg/icon_add.svg'
import iconAdded from '../../assets/svg/icon_added.svg'
import './SchoolDetail.less'

class Detail extends Component {

  state = {
    showToast: false,
    toastIcon: 'deleted',
    toastText1: '',
    toastText2: '',
  }

  handleAdd(data, selected,e) {
      const { selectedSchoolIds,selectedSchoolList } = this.props;
      const modify = data.id;
      if(selected){
          const newIds = without(selectedSchoolIds, modify);
          const newList=selectedSchoolList.filter(i=>i.id!=modify);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'deleted' ,
                  toastText1:  '已删除' ,
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }else {
          const newIds = union(selectedSchoolIds, [modify]);
          const newList= union(selectedSchoolList,[data]);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'success',
                  toastText1: '已添加',
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }
  }

  handleBackToWish() {
    const { history } = this.props
    history.push(`/schoolwishlist`)
  }
  handleBackToChoose(){
      const { history } = this.props
      history.push(`/schoolwishlist/choose`)
  }
  renderBtn(school) {
    const { selectedSchoolIds } = this.props
    const added = selectedSchoolIds.includes(school.id)
    const cls1 = classNames({
      'btn-operation': true,
      'added': added,
    });
    return <div className={cls1} onClick={this.handleAdd.bind(this, school, added)}>
      <img className="icon-add" src={added ? iconAdded : iconAdd} alt="icon" />
      <span>{added ? '已选' : '选择'}</span>
    </div>
  }

  render() {
    const {
      showToast,
      toastIcon,
      toastText1,
      toastText2,
    } = this.state
    return (
      <div className="school-detail-wrapper">
        <SchoolDetail
          renderOperationBtn={this.renderBtn.bind(this)}
          onBack={this.handleBackToChoose.bind(this)}
          {...this.props}
        />
        <div className="bottom-btn">
          <button className="primary full" onClick={this.handleBackToWish.bind(this)}>返回意向学校清单</button>
        </div>
        <Toast show={showToast} icon={toastIcon} onHide={() => this.setState({ showToast: false })}>
          <i>{toastText1}</i>
          <p>{toastText2}</p>
        </Toast>
      </div>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/pages/SchoolWishList/SchoolDetail.js